export type BranchingErrorKind =
  "conflict" | "invalid" | "name-taken" | "not-found" | "protected-branch" | "unavailable" | "unknown";

export class BranchingError extends Error {
  kind: BranchingErrorKind;
  override cause: unknown;

  constructor(kind: BranchingErrorKind, message: string, cause?: unknown) {
    super(message);
    this.name = "BranchingError";
    this.kind = kind;
    this.cause = cause;
  }
}
